module.exports = __webpack_public_path__ + "static/media/solution-2.dff03a92.png";